module.exports = __webpack_public_path__ + "img/off-active.177b5a59.svg";